import authenticationModule from "./authentication"

const module = {
  namespaced: true,
  modules: {
   authenticationModule
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  }
};

export default module;
